/* ============================================================
   Souvenir — Itinerary Accordion
   Vanilla JS only. No libraries.
   Visibility is driven ENTIRELY by CSS off the aria-expanded
   state (see itinerary.css FIX 2). JS only flips aria-expanded
   on click — it sets NO inline display and does NOT touch the
   `hidden` attribute, so CSS (with !important) is the single
   source of truth and cannot be defeated by stale inline styles.
   v2 — cache-bust: switched from inline-display to aria-only.
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  const selector =
    '.itinerary-day__header[aria-expanded], .itinerary-section__header[aria-expanded], .itinerary-at-a-glance__header[aria-expanded]';
  document.querySelectorAll(selector).forEach((button) => {
    const target = document.getElementById(button.getAttribute('aria-controls'));

    // Remove the source `hidden` attribute so CSS alone controls
    // visibility from here on (CSS already collapses by default).
    if (target) {
      target.hidden = false;
    }

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
    });
  });
});
